import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"
import Sortable from "../vendor/sortable.esm.min.js"

// Connects to data-controller="kartensort"
export default class extends Controller {
  	static targets = ["kartenSortFormular"]

  	connect() {
		this.sortable = new Sortable(this.element, {
						animation: 150,
						handle: ".sort-element",
						onEnd: () => this.updateKartenreihenfolge()
				})
  	}

	disconnect() {
		this.sortable?.destroy()
	}

	updateKartenreihenfolge() {
		this.kartenSortFormularTargets.forEach((kartenForm, index) => {
		const positionField = kartenForm.querySelector(".position_field")
		const newKartenPosition = index + 1
		positionField.value = newKartenPosition
		this.sendRequest(kartenForm.action, new FormData(kartenForm));
		})
	}

	sendRequest(url, formData) {
		patch(url, { responseKind: "turbo-stream", body: formData })
	}

}
